<template>
  <div class="flex column settings-css manage">
    <div
      v-if="(!checkPermission('manage_template_messages') && !checkPermission('manage_settings')) || forbidden" >
      <h1 class="settings__title" >
        <div
          class="back-btn"
          @click="goBack('WAManage')">
          <SBIcon
            class="mr-2"
            :icon="SBIconList.DOWN_ARROW"
            :color="SBColors.greyPrimary"
            :size="12"
            :rotate="90" />
          <p>Message Templates</p>
        </div>
      </h1>
      <Forbidden />
    </div>
    <div
      v-else
      class="settings--limit-width flex column">
      <h1 class="settings__title" >
        <div
          class="back-btn"
          @click="goBack('WAManage')">
          <SBIcon
            class="mr-2"
            :icon="SBIconList.DOWN_ARROW"
            :color="SBColors.greyPrimary"
            :size="12"
            :rotate="90" />
          <p>Message Templates</p>
        </div>
      </h1>

      <Spinner
        v-if="showView === 'initializing'"
        class="mt-5"
        :size="20"
        :thickness="2" />

      <InfoCard
        v-if="showView === 'noTemplates'"
        :flat-icon="SBIconList.MESSAGE_TEMPLATES_LOGO"
        title="Add WhatsApp Message Templates"
        :description="noTemplatesDescription"
        action-text="Add"
        @action="openMessageTemplateModal" />

      <template v-if="showView === 'templateList'">
        <div class="actions-bar">
          <div
            class="flex">
            <SearchInput
              ref="searchInput"
              v-model="searchQuery"
              placeholder="Search Message Templates..."
              @input="searchTemplateMessages" />
            <!-- *************************************** -->
            <!-- Tag filtering -->
            <!-- *************************************** -->
            <!-- button -->
            <div class="sb2-wrapper mr-2 greedy">
              <button
                class="filter-button sb2-bordered sb2-hoverable sb2-focusable"
                @click="filterMenuToggle">
                <span class="filter-button-main-content">
                  <span class="sb2-icon filter size-12" />
                  Filter
                </span>
                <span
                  v-if="selectedFilters.length"
                  class="filter-button-filter-count">
                  {{ selectedFilters.length }}
                </span>
              </button>
              <!-- menu -->
              <div
                v-if="filterMenuIsOpen"
                v-click-outside="filterMenuClose"
                class="sb2-dropdown highlight-checked">
                <searchable-list
                  title="Filters"
                  :item-list="filterOptions"
                  :filter-fn="tagFilterSearchFn"
                  :clear-all-displayed="selectedFilters.length > 0"
                  @item-selected="selectFilter"
                  @clear-all="deselectFilter">
                  <template #default="slotProps">
                    <div
                      class="sb2-dropdown-item"
                      :class="{checked: selectedFilters.findIndex(filter => filter.value === slotProps.item.value) >= 0}">
                      <span
                        class="title-wrap ellipsis"
                        :inner-html.prop="slotProps.item.name | boldMatch(slotProps.searchTerm)" />
                      <SBIcon
                        v-if="selectedFilters.findIndex(filter => filter.value === slotProps.item.value) >= 0"
                        :icon="SBIconList.DONE_TICK"
                        :color="SBColors.bluePrimary"
                        :size="9" />
                    </div>
                  </template>
                </searchable-list>
              </div>
            </div>
            <b-button
              class="flex center-all"
              @click="openMessageTemplateModal">
              <SBIcon
                class="mr-2"
                :icon="SBIconList.PLUS"
                :color="SBColors.blackPrimary"
                :size="8"/>
              <span>New</span>
            </b-button>
          </div>
        </div>

        <div
          v-if="!templateMessagesLoaded && page === 1"
          class="no-data flex center-all">
          <Spinner
            :size="20"
            :thickness="2" />
        </div>

        <template v-else-if="templatesAppended.length > 0">
          <b-row class="data-wrapper greedy">
            <b-col
              class="m-0 p-0 templates__list"
              lg="6" >
              <ScrollArea @bottom="nextPage" >
                <!-- Template type shown -->
                <p
                  class="template__type" >
                  {{ filteredStatusesTitle }}
                </p>
                <div
                  v-for="(template, index) in templatesAppended"
                  :key="index" >
                  <!-- Log item -->
                  <div
                    class="template__item flex center-all"
                    :class="{active: template.id === selectedTemplate.id}"
                    @click="selectTemplate(template)" >
                    <span
                      class="template__status no-shrink"
                      :class="getStatusColor(template.status)">{{ template.status.toLowerCase() === 'pending' ? 'Review' : template.status }}</span>
                    <span
                      class="template__name greedy ellipsis"
                      :inner-html.prop="(template.name ? template.name : template.keyword) | boldMatch(searchQueryAfterDebounce)" />
                    <!-- <span class="template__date">{{ template.updated_at | hhmmss }}</span> -->
                  </div>
                </div>

                <!-- <Paging
                  :current-page="3"
                  :total-pages="5"
                  :load-more-mode="true"
                  :loading="!false"
                  class="bottom-40"
                  @page="() => {}" /> -->
              </ScrollArea>
            </b-col>
            <b-col
              class="template-data"
              lg="6" >
              <ScrollArea v-if="selectedTemplate && selectedTemplate.status" >
                <div class="bottom-20">
                  <div class="flex flex-align-center">
                    <h3 class="greedy mr-3"><strong>{{ selectedTemplate.name ? selectedTemplate.name : selectedTemplate.keyword }}</strong></h3>

                    <b-dropdown
                      no-caret
                      right
                      toggle-class="settings-action"
                      @show="menuOpen = true"
                      @hide="menuOpen = false" >
                      <template #button-content>
                        <span
                          class="menu-button flex center-all"
                          :class="{active: menuOpen}" />
                      </template>
                      <b-dropdown-item @click.stop.prevent="editTemplate(selectedTemplate)">Edit</b-dropdown-item>
                      <b-dropdown-item @click.stop.prevent="deleteTemplate(selectedTemplate)">Delete</b-dropdown-item>
                    </b-dropdown>
                  </div>

                  <div
                    v-if="selectedTemplate.rejected_reason"
                    class="rejected-reason">
                    <SBIcon
                      :icon="SBIconList.ERROR"
                      :color="SBColors.redPrimary"
                      :size="12" />
                    <span>{{ selectedTemplate.rejected_reason }}</span>
                  </div>

                  <div class="template-info">
                    <span class="template-info-title no-shrink" >Status</span>
                    <span class="template-info-value" >
                      <span
                        class="template__status"
                        :class="getStatusColor(selectedTemplate.status)">
                        {{ selectedTemplate.status.toLowerCase() === 'pending' ? 'Review' : selectedTemplate.status }}
                      </span>
                    </span>
                  </div>
                  <div class="template-info">
                    <span class="template-info-title no-shrink" >Type</span>
                    <span class="template-info-value first-up" >{{ selectedTemplate.category }}</span>
                  </div>
                  <!-- <div class="template-info">
                    <span class="template-info-title" >Language</span>
                    <span class="template-info-value" >{{ getLanguageName(selectedTemplate.language, false) }}</span>
                  </div> -->
                  <div class="template-info">
                    <span class="template-info-title no-shrink" >Media</span>
                    <span class="template-info-value first-up" >{{ !selectedTemplate.attachment || selectedTemplate.attachment.toLowerCase() === 'null' ? 'No' : selectedTemplate.attachment }}</span>
                  </div>
                  <div
                    v-if="['approved', 'rejected'].includes(selectedTemplate.status)"
                    class="template-info">
                    <span class="template-info-title no-shrink" >Time {{ selectedTemplate.status === 'approved' ? 'approved' : 'rejected' }}</span>
                    <span class="template-info-value" >{{ selectedTemplate.updated_at | dateTimeFull }}</span>
                  </div>
                  <div class="template-info">
                    <span class="template-info-title no-shrink" >Time submitted</span>
                    <span class="template-info-value" >{{ selectedTemplate.created_at | dateTimeFull }}</span>
                  </div>
                  <div class="template-info">
                    <SBIcon
                      id="keyword-info"
                      :icon="SBIconList.INFO"
                      :color="SBColors.greyPrimary"
                      :size="12"/>
                    <b-popover
                      target="keyword-info"
                      triggers="hover"
                      placement="top"
                      boundary="window" >
                      <div>
                        <h1>Message template keyword</h1>
                        <p>This keyword is automatically generated and uniquely identifies this message template. Message template keyword cannot be edited once it has been generated.</p>
                      </div>
                    </b-popover>
                    <span class="template-info-title ml-1" >Keyword</span>
                    <span class="template-info-value ellipsis" >{{ selectedTemplate.keyword }}</span>
                    <CopyNumber
                      :value="selectedTemplate.keyword"
                      class="big-copy"
                      @click.native.stop />
                  </div>
                </div>

                <!-- Message text -->
                <div class="bottom-20">
                  <h5>Message</h5>

                  <div
                    class="template-message-wrapper"
                    :class="{ document: hasAttachment }" >
                    <div
                      class="template-message"
                      :class="{ buttons: selectedTemplate.buttons }">
                      <div
                        v-if="hasAttachment"
                        class="attachment"
                        :class="[selectedTemplate.attachment.toLowerCase()]" />

                      <!-- No user input is rendered here. -->
                      <!-- eslint-disable vue/no-v-html  -->
                      <div
                        class="message-body tag-content"
                        v-html="whatsAppFormatToHTML(selectedTemplateConvertedText)" />
                    </div>

                    <!-- BUTTONS -->
                    <template v-if="selectedTemplate.buttons">
                      <div
                        v-for="(button, index) in selectedTemplate.buttons"
                        :id="`button-${index}`"
                        :key="index"
                        class="button" >
                        <img
                          v-if="button.icon"
                          :src="button.icon.dark"
                          height="12"
                          class="menu-icon mr-2" >
                        <span class="ellipsis">
                          {{ button.title }}
                        </span>
                        <!-- Only allow copy if the url or phone button -->
                        <div
                          v-if="['PHONE_NUMBER', 'URL'].includes(button.type)"
                          class="copy-me-wrapper">
                          <div
                            v-clipboard="button.value || button.title"
                            class="copy-me"
                            @success="copyToClipboard"
                            @error="copyToClipboard(false)" />
                        </div>
                        <b-popover
                          v-if="['PHONE_NUMBER', 'URL'].includes(button.type)"
                          :target="`button-${index}`"
                          boundary="window"
                          triggers="hover"
                          placement="top"
                          :delay="{ show: 50, hide: 0 } "
                          custom-class="basic-popover button-popover" >
                          <template v-if="button.value">
                            {{ button.value.substring(0, 100).replace(/\/\{*\{*\d*\}*\}*$/, '') }}{{ button.value.length > 100 ? '...' : '' }}
                            <span v-if="button.value.endsWith('\{\{1\}\}')" >/</span>
                            <span
                              v-if="button.value.endsWith('\{\{1\}\}')"
                              class="blue" >{{ '\{\{1\}\}' }}</span>
                          </template>
                        </b-popover>
                      </div>
                    </template>
                  </div>

                </div>
              </ScrollArea>
            </b-col>
          </b-row>
        </template>
        <!-- <div
          v-else
          class="no-data flex center-all" >
          <span class="wrapper flex center-all">
            <span class="emoji">😐</span>
            <p>No data is available at the moment</p>
          </span>
        </div> -->

        <div
          v-else
          class="no-data flex center-all" >
          <div class="flex center-all">
            <template v-if="searchQueryAfterDebounce && selectedFilters.length">
              <span class="wrapper flex center-all">
                <span class="emoji">😐</span>
                <p>We couldn’t find anything for <strong>{{ searchQueryAfterDebounce }}</strong> and selected statuses</p>
              </span>
            </template>
            <template v-else-if="searchQueryAfterDebounce">
              <span class="wrapper flex center-all">
                <span class="emoji">😐</span>
                <p>We couldn’t find anything for <strong>{{ searchQueryAfterDebounce }}</strong></p>
              </span>
            </template>
            <template v-else-if="selectedFilters.length">
              <span class="wrapper flex center-all">
                <span class="emoji">😐</span>
                <p>We couldn’t find anything for selected statuses</p>
              </span>
            </template>
            <template v-else>
              <span class="wrapper flex center-all">
                <span class="emoji">😐</span>
                <p>No data is available at the moment</p>
              </span>
            </template>
          </div>
        </div>
      </template>
      <MessageTemplateModal
        ref="messageTemplateModalRef"
        :business-id="$route.params.businessId"
        @created="templateCreated"
        @updated="templateUpdated" />
    </div>
  </div>
</template>

<script>
import { debounce } from 'debounce';
import { mapActions, mapGetters } from 'vuex';

import ToasterMixin from '@/mixins/Toaster';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import getLanguageName from '@/helpers/getLanguageName';
import { convertToTagView, whatsAppFormatToHTML } from '@/helpers/stringHelpers';
import Spinner from '@/components/common/Spinner';
import ScrollArea from '@/components/common/ScrollArea';
import InfoCard from '@/components/common/InfoCard';
import SearchInput from '@/components/business/widgets/SearchInput';
import MessageTemplateModal from '@/components/business/settings/modals/MessageTemplate.modal';
import SearchableList from '../../common/SearchableList';
import NoPermissionMixin from '@/mixins/AccessPermission';
import UserPermissionsMixin from '@/mixins/UserPermissions.mixin';
import CopyNumber from '../../common/CopyNumber';
import CommonActions from '@/components/manage/CommonActions.mixin';

export default {
  name: 'MessageTemplates',
  components: {
    SBIcon,
    Spinner,
    ScrollArea,
    InfoCard,
    SearchInput,
    MessageTemplateModal,
    SearchableList,
    CopyNumber,
  },
  mixins: [
    ToasterMixin,
    NoPermissionMixin,
    UserPermissionsMixin,
    CommonActions,
  ],
  data() {
    return {
      whatsappPolicyUrl: 'https://www.whatsapp.com/legal/business-policy/',
      noTemplatesDescription: '',
      searchQuery: '',
      searchQueryAfterDebounce: '',
      initialMessageTemplateRequestFinished: false,
      templatesAppended: [],
      selectedTemplate: null,
      menuOpen: false,
      templatesFetchingCounter: 0,
      page: 1,
      limit: 300,
      status: '',
      meta: {},
      modalVisible: false,
      selectedFilters: [],
      filterOptions: [
        {
          name: 'Approved',
          value: 'approved',
          order: 1,
        },
        {
          name: 'Under review',
          value: 'pending',
          order: 2,
        },
        {
          name: 'Rejected',
          value: 'rejected',
          order: 3,
        },
      ],
      dateRange: {
        startDate: '',
        endDate: '',
      },
      filterMenuIsOpen: false,
      SBIconList,
      SBColors,
    };
  },
  computed: {
    ...mapGetters({
      templateMessageList: 'notification/templateMessageList',
      templateMessagesLoaded: 'notification/templateMessagesLoaded',
      templateMessageDeleted: 'notification/templateMessageDeleted',
      templateMessageValidationFailed: 'notification/templateMessageValidationFailed',
      apiError: 'notification/apiError',
      userPermissions: 'user/userPermissions',
    }),
    hasAttachment() {
      return this.selectedTemplate.attachment && this.selectedTemplate.attachment.toLowerCase() !== 'null';
    },
    showView() {
      let view = 'initializing';
      if (this.templatesFetchingCounter > 1 || (this.initialMessageTemplateRequestFinished && this.templatesAppended.length)) {
        view = 'templateList';
      } else if (this.initialMessageTemplateRequestFinished && this.templatesFetchingCounter === 1 && !this.templatesAppended.length) {
        view = 'noTemplates';
      }
      return view;
    },
    selectedTemplateConvertedText() {
      return convertToTagView(this.selectedTemplate.text);
    },
    // TODO this is a good candidate to make a filter of it. Filter should have a default sorting function but should be able to accept custom one.
    filteredStatusesTitle() {
      let title = 'All';

      if (this.selectedFilters.length && this.selectedFilters.length < this.filterOptions.length) {
        title = '';
        [...this.selectedFilters].sort((a, b) => a.order - b.order).forEach((option, index) => {
          if (index === 0) {
            title += option.name;
          } else if (index + 1 === this.selectedFilters.length) {
            title += ` and ${option.name}`;
          } else {
            title += `, ${option.name}`;
          }
        });
      }

      return title;
    },
  },
  watch: {
    business() {
      this.searchQuery = null;
      this.searchQueryAfterDebounce = null;
      this.initialMessageTemplateRequestFinished = false;
      this.page = 1;
      this.templatesAppended = [];
      this.templatesFetchingCounter = 0;
      if ((this.checkPermission('manage_template_messages') || this.checkPermission('manage_settings')) && this.business.id) {
        this.loadMoreTemplates();
      }
    },
    templateMessagesLoaded() {
      if (this.templateMessagesLoaded && !this.initialMessageTemplateRequestFinished) {
        this.initialMessageTemplateRequestFinished = true;
      }

      if (this.templateMessagesLoaded) {
        if (this.page === 1) {
          this.templatesAppended = [];
        }
        this.templatesAppended = [...this.templatesAppended, ...this.templateMessageList.data];
        if (this.page === 1 && this.templatesAppended.length) {
          this.selectTemplate(this.templatesAppended[0]);
        }
        this.meta = this.templateMessageList.meta;
      }
    },
    templateMessageDeleted() {
      if (this.templateMessageDeleted) {
        this.$confirmPluginModal.close();
        this.showToaster(`Message Template <b>${this.selectedTemplate.name ? this.selectedTemplate.name : this.selectedTemplate.keyword}</b> has been successfully deleted.`, null, null, 'OK');
        const templateToDeleteId = this.selectedTemplate.id;
        // Get the index of the template to be deleted so the next one can be selected
        const deletedIndex = this.templatesAppended.findIndex(template => template.id === templateToDeleteId);
        this.templatesAppended = this.templatesAppended.filter(template => template.id !== templateToDeleteId);
        if (this.templatesAppended.length && this.templatesAppended.length > deletedIndex) {
          this.selectTemplate(this.templatesAppended[deletedIndex]); // select the one after the deleted which now took his place
        } else if (this.templatesAppended.length && this.templatesAppended.length === deletedIndex) {
          this.selectTemplate(this.templatesAppended[this.templatesAppended.length - 1]); // select LAST available
        } else if (!this.templatesAppended.length && !this.searchQueryAfterDebounce && !this.selectedFilters.length) { // case when there is no templates // Only act if there is no filter or search present
          this.searchQuery = null;
          this.searchQueryAfterDebounce = null;
          this.initialMessageTemplateRequestFinished = false;
          this.page = 1;
          this.templatesAppended = [];
          this.templatesFetchingCounter = 0;
          this.loadMoreTemplates();
        }
      }
    },
    templateMessageValidationFailed() {
      if (!this.modalVisible) {
        this.showToaster(this.templateMessageValidationFailed.error_message, null, 'warning', 'warning');
      }
      this.templatesAppended = this.templatesAppended.filter(template => template.id !== this.templateMessageValidationFailed.template_uid);
      this.selectTemplate(this.templatesAppended[0]);
    },
    userPermissions() {
      if ((this.checkPermission('manage_template_messages') || this.checkPermission('manage_settings')) && this.$route.params.businessId) {
        this.searchQuery = null;
        this.searchQueryAfterDebounce = null;
        this.initialMessageTemplateRequestFinished = false;
        this.page = 1;
        this.templatesAppended = [];
        this.templatesFetchingCounter = 0;
        this.loadMoreTemplates();
      }
    },
  },
  mounted() {
    this.noTemplatesDescription = `Create Message Templates so you can initiate a WhatsApp conversation or respond to a conversation if more than 24 hours have passed from the last message sent by the contact. Visit <a href='${this.whatsappPolicyUrl}' target='_blank'>WhatsApp Business Legal</a> for more information.`;
    // in case user returns to the page. On first mount business is undefined so this will not trigger
    if ((this.checkPermission('manage_template_messages') || this.checkPermission('manage_settings')) && this.$route.params.businessId) {
      this.loadMoreTemplates();
    }
    this.finalizeSplashView();

    this.$root.$on('bv::modal::shown', (bvEvent, modalId) => {
      if (modalId === 'message-templates-modal') {
        this.modalVisible = true;
      }
    });
    this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
      if (modalId === 'message-templates-modal') {
        this.modalVisible = false;
      }
    });
  },
  methods: {
    ...mapActions({
      fetchTemplateMessages: 'notification/fetchTemplateMessages',
      deleteTemplateMessage: 'notification/deleteTemplateMessage',
      finalizeSplashView: 'organisation/finalizeSplashView',
    }),
    getLanguageName,
    whatsAppFormatToHTML,
    copyToClipboard(success = true) {
      if (success) {
        this.showToaster('Copied to clipboard.', null, null, 'OK');
      }
    },
    // Obsolete. List is now returned as paginated array instead of object with keys and keywords which groups additional langiages
    extractTemplates() {
      const templates = [];
      Object.keys(this.templateMessageList).forEach((templateKeyname) => {
        this.templateMessageList[templateKeyname].forEach((template) => {
          templates.push(template);
        });
      });
      return templates;
    },
    selectTemplate(template) {
      this.selectedTemplate = template;
    },
    getStatusColor(status) {
      switch (status) {
        case 'approved': {
          return 'approved';
        }
        case 'rejected': {
          return 'rejected';
        }
        // will cover review state or any other if needed
        default: {
          return 'default-status';
        }
      }
    },
    openMessageTemplateModal() {
      this.$refs.messageTemplateModalRef.show();
    },
    editTemplate(template) {
      this.$refs.messageTemplateModalRef.show(template);
    },
    deleteTemplate(template) {
      this.$confirmPluginModal.show({
        title: 'Delete WhatsApp Message Template',
        message: `Are you sure you want to delete <b>${template.name ? template.name : template.keyword}</b>?`,
        confirmButtonText: 'Delete',
        buttonVariant: 'RED',
        confirmCallback: () => {
          this.deleteTemplateMessage({
            merchantId: this.$route.params.businessId,
            templateId: template.id,
          });
        },
      });
    },
    filterMenuToggle() {
      this.filterMenuIsOpen = !this.filterMenuIsOpen;
    },
    filterMenuClose() {
      this.filterMenuIsOpen = false;
    },
    tagFilterSearchFn(searchTerm) {
      return item => item.name && item.name.toLowerCase().indexOf(searchTerm) !== -1;
    },
    selectFilter(option) {
      const optionIndex = this.selectedFilters.findIndex(selectedOption => option.value === selectedOption.value);
      if (optionIndex > -1) {
        this.selectedFilters.splice(optionIndex, 1);
      } else {
        this.selectedFilters.push(option);
      }
      this.page = 1;
      this.loadMoreTemplates();
    },
    deselectFilter() {
      this.selectedFilters = [];
      this.page = 1;
      this.loadMoreTemplates();
    },
    searchTemplateMessages: debounce(function f() {
      this.searchQueryAfterDebounce = this.searchQuery;
      this.page = 1;
      this.loadMoreTemplates();
    }, 500),
    nextPage() {
      if (this.page < this.meta.last_page) {
        this.page += 1;
        this.loadMoreTemplates();
      }
    },
    loadMoreTemplates() {
      this.templatesFetchingCounter++;
      const payload = {
        businessId: this.$route.params.businessId,
        data: {
          limit: this.limit,
          page: this.page,
          status: this.selectedFilters.map(filter => filter.value).toString(),
          name: this.searchQuery,
          // start_date: this.dateRange.startDate,
          // end_date: this.dateRange.endDate,
        },
      };
      this.fetchTemplateMessages(payload);
    },
    templateUpdated({ templateId, newTemplateName }) {
      const editedTemplate = this.templatesAppended.find(template => template.id === templateId);
      editedTemplate.name = newTemplateName;
    },
    templateCreated(template) {
      this.templatesAppended = this.$lodash.uniqBy([template, ...this.templatesAppended], 'id');
      this.selectTemplate(this.templatesAppended[0]);
    },
  },
};
</script>

<style lang="scss" scoped>
.settings--limit-width {
  max-height: 100% !important;
}

::v-deep .bottom-20 {
  margin-bottom: 20px;
  border-bottom: 1px solid $greyBorderSecondary;
}

.actions-bar {
  margin-top: 35px;
  margin-bottom: 15px;
}


.data-wrapper {
  overflow: hidden;
  border-top: 1px solid $greyBorderSecondary;
}

.date-picker-wrapper {
  margin-top: 35px;
  margin-bottom: 15px;
}

.row {
  margin: 0 !important;
}

.rejected-reason {
  background-color: #ffebec;
  border: 1px solid #f7e2e3;
  padding: 10px 14px;
  margin: 0px 0 20px;
  border-radius: 10px;
  color: $redPrimary;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.37;
  display: inline-flex;
  align-items: center;

  .sb-icon {
    margin-right: 10px;
  }
}

.template-data {
  height: 100%;
  overflow: auto;
  padding: 0 0 0 40px;

  .v-scroll-visible {
    padding-right: 40px;
  }

  h3 {
    margin: 20px 0 20px 0;
    font-size: 16px;
    font-weight: 400;
    color: $blackPrimary;
    cursor: default;

    strong {
      font-weight: 500;
    }
  }

  ::v-deep .settings-action {
    margin-right: 5px;
    border: none !important;
    background: none !important;
    box-shadow: none !important;
    padding: 0 !important;
    height: fit-content !important;

    &:active, &:focus, &:hover {
      border: none !important;
      background: none !important;
      outline: none !important;
      box-shadow: inherit !important;
    }

    .menu-button {
      background-image: url('~@/assets/img/SB-Icons/menu-3-dots-dark.svg');
      background-size: 16px 16px;
      width: 28px;
      height: 16px;
      border-radius: 5px;
      background-repeat: no-repeat;
      background-position: center;

      // menu button state when button is hovered or menu is open
      &:hover, &.active {
        box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.3);
        border: solid 1px #cfd8dc;
        background-color: $white;
      }
    }
  }

  .template-info {
    cursor: default;
    min-height: 22px;
    display: flex;
    align-items: center;

    .template-info-title {
      font-size: 14px;
      font-weight: 400;
      color: $blackUltralight;
      margin-right: 8px;
    }

    .template-info-value {
      font-size: 14px;
      font-weight: 400;
      color: $blackPrimary;

      &.first-up {
        text-transform: lowercase;
        &::first-letter {
          text-transform: uppercase !important;
        }
      }
    }

    .template__status {
      text-align: center;
      font-size: 12px;
      font-weight: 500;
      border-radius: 3px;
      display: inline-block;
      text-transform: capitalize;

      &.approved {
        padding: 3px 8px;
        color: $blackPrimary;
        border: 1px solid #e5e9eb;
        background-color: #edf0f2;
      }

      &.default-status {
        padding: 3px 8px;
        color: #cea111;
        border: 1px solid #f5edd4;
        background-color: #fff7dd;
      }

      &.rejected {
        padding: 3px 8px;
        color: #ff5b61;
        border: 1px solid #f7e2e3;
        background-color: #ffebec;
      }
    }
  }

  h5 {
    font-size: 14px;
    font-weight: 500;
    color: $blackPrimary;
    margin: 0 0 15px 0;
  }

  .template-message-wrapper {
    width: fit-content;
    max-width: 288px;

    &.document {
      width: 100%;
    }

    .template-message {
      border-radius: 19px;
      overflow: hidden;
      border: 2px solid $bluePrimary;

      .attachment {
        background-color: #f0f6fe;
        height: 95px;
        &::after {
          content: '';
          display: block;
          width: 100%;
          height: 100%;
          background-image: unset !important;
          background-color: #65a5f1 !important;
          mask: url(~@/assets/img/SB-Icons/doc-new.svg) no-repeat center !important;
          mask-size: 26px 26px !important;
        }

        &.image::after {
          mask: url(~@/assets/img/SB-Icons/image-placeholder.svg) no-repeat center !important;
          mask-size: 26px 26px !important;
        }

        &.video::after {
          mask: url(~@/assets/img/SB-Icons/video-placeholder.svg) no-repeat center !important;
          mask-size: 26px 26px !important;
        }
      }

      .message-body {
        background-color: $bluePrimary;
        padding: 5px 12px;
        white-space: pre-wrap;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.37;
        color: $white;

        ::v-deep .template-tag {
          color: $white !important;
          border-color: $white !important;
          background-color: #4190ed !important;
          margin-right: 1px;
        }
      }

      &.buttons {
        border-bottom-left-radius: 3px;
        border-bottom-right-radius: 3px;
      }

      ::v-deep {
        p {
          min-height: 10px;
        }
      }
    }

    &.document .template-message .message-body {
      padding: 7px 11px;
    }
  }

  .button {
    margin-top: 3px;
    border: 1px solid #b1cff2;
    border-radius: 3px !important;
    color: $bluePrimary;
    background-color: $white;
    width: 100%;
    box-shadow: none;
    justify-content: center;
    overflow: hidden;
    cursor: default;
    position: relative;

    .copy-me-wrapper {
      position: absolute;
      opacity: 0;
      right: 5px;
      width: 30px;
      height: 20px;
      background: rgb(255,255,255);
      background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 43%, rgba(255,255,255,1) 100%);

      .copy-me {
        position: absolute;
        right: 0;
        cursor: pointer;
        margin: 4px 0 4px;
        display: block;
        width: 20px;
        height: 12px;
        background-image: url('~@/assets/img/SB-Icons/copy.svg');
        background-repeat: no-repeat;
        background-position: center;

        &:hover {
          background-image: url('~@/assets/img/SB-Icons/copy-hover.svg');
        }
      }
    }

    &:last-of-type {
      border-bottom-left-radius: 19px !important;
      border-bottom-right-radius: 19px !important;
    }

    &:hover .copy-me-wrapper {
      opacity: 1;
    }
  }
}

::v-deep .templates__list {
  height: 100%;
  overflow: auto;
  padding-right: 0px !important;
  border-right: 1px solid $greyBorderSecondary;

  .scroll-container {
    padding-top: 20px;
    padding-right: 40px;
    padding-bottom: 20px;
  }

  .template__type {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 12px;
  }

  .template__item {
    padding: 8px 10px;
    margin-bottom: 2px;
    border-radius: 5px;
    cursor: pointer;

    .template__status {
      text-align: center;
      min-width: 72px;
      font-size: 12px;
      font-weight: 500;
      border-radius: 3px;
      text-transform: capitalize;

      &.approved {
        padding: 3px 8px;
        color: $blackPrimary;
        border: 1px solid #e5e9eb;
        background-color: #edf0f2;
      }

      &.default-status {
        padding: 3px 8px;
        color: #cea111;
        border: 1px solid #f5edd4;
        background-color: #fff7dd;
      }

      &.rejected {
        padding: 3px 8px;
        color: #ff5b61;
        border: 1px solid #f7e2e3;
        background-color: #ffebec;
      }
    }

    .template__type {
      font-family: monospace;
      font-size: 14px;
      font-weight: 500;
      padding-left: 12px;
      padding-right: 10px;;
      color: $blackUltralight;
    }

    .template__name,
    .template__date {
      font-size: 14px;
      font-weight: 400;
      color: $blackUltralight;
    }

    .template__name {
      padding-left: 12px;
      line-height: 20px;
    }

    .template__url {
      font-family: monospace;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-right: 15px;
    }

    &:hover {
      background-color: #fafbfc;
      .template__url, .template__date, .template__type, .template__name {
        color: $blackPrimary;
      }
    }

    &.active {
      background-color: #f6f8f9;
      .template__url, .template__date, .template__type, .template__name {
        color: $blackPrimary;
      }
    }
  }
}
</style>

<style lang="scss">
  .button-popover {
    max-width: 450px;

    .popover-body {
      display: inline-flex;
      .blue {
        color: $bluePrimary !important;
        font-weight: 500;
      }
    }
  }
</style>
